
<div class="flex"><span class="mr-2">{{languageVoice.language}}</span>
  <audio class="audio-xs" controls="controls">
    <source src="{{languageVoice.signedURL}}" type="audio/wav"/>
  </audio>
  <div class="fas fa-edit pointer ml-2" (click)="onClickEditEmitter.emit()"></div>
</div>